import { Nullable } from 'cng-common/models/utils'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import { IWsSectionSettings, IWsSectionSettingsRaw } from './models/iWsSectionSettings'

export interface IChangeSectionSettingsParameters {
  partnerId: string
  fYear: number
  ownerId: string
  controlName: 'SoB' | 'Planning' | 'Assortment'
  flag: string
  state: Nullable<number | string>
  comment?: string
  saveExtendedInfo?: 1 | 0
}

export const changeSectionSettings = async ({
  partnerId,
  fYear,
  ownerId,
  controlName,
  flag,
  state,
  comment,
  saveExtendedInfo,
}: IChangeSectionSettingsParameters): Promise<Partial<IWsSectionSettings>> => {
  try {
    const wsClient = WebSocketStore.get('partner360')
    const [token] = getTokens(ownerId)

    const res = await wsClient.call<IWsSectionSettingsRaw[]>({
      service: 'sectionSettings',
      action: 'setSectionSettings',
      payload: {
        partnerId,
        fYear,
        controlName,
        flag,
        state,
        comment,
        saveExtendedInfo,
      },
      token: token || undefined,
      withoutTokenRefresh: true,
      isAuth: true,
    })

    if (!res.data.length) {
      return {}
    }

    const [raw] = res.data
    if (raw.SectionSettings === null) {
      return {}
    }

    return JSON.parse(raw.SectionSettings)
  } catch (e: any) {
    return {}
  }
}
